// Vite が import.meta.env として注入する環境変数。
// 本番では VITE_API_BASE を Pages の env で設定する。
export const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");
const DEFAULT_LOCAL_PUBLIC_SITE_BASE = "http://127.0.0.1:8787";
const RAW_PUBLIC_SITE_BASE = import.meta.env.VITE_PUBLIC_SITE_BASE ?? API_BASE;
export const PUBLIC_SITE_BASE = (
  RAW_PUBLIC_SITE_BASE || DEFAULT_LOCAL_PUBLIC_SITE_BASE
).replace(/\/$/, "");

/**
 * `/api/...` を実際の URL に変換。
 * - 開発: API_BASE が空 → vite dev proxy で `/api` を nova に投げる
 * - 本番: API_BASE が空でない → そこに直接 fetch
 */
export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${p}` : p;
}

export function apiAbsoluteUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  const origin =
    API_BASE ||
    (typeof window !== "undefined" ? window.location.origin : "");
  return origin ? `${origin}${p}` : p;
}

/**
 * クッション広告の公開URL (`/s/:id`) を返す。
 * 配信は worker が担うため、管理画面 origin ではなく worker origin の
 * 絶対URLを使う。
 */
export function publicSiteUrl(siteId: string): string {
  return `${PUBLIC_SITE_BASE}/s/${siteId}`;
}
